import Assets from "./output/assets.js";
import Labels from "./output/labels.js";

class Output {
    constructor(wrapCtx, evtCtx, shlWrapCtx, shlEvtCtx, controllers) {
        this._assets = new Assets(wrapCtx, evtCtx, shlWrapCtx, shlEvtCtx, controllers.assets);
        this._labels = new Labels(wrapCtx, evtCtx, shlWrapCtx, shlEvtCtx, controllers.labels);
    }

    get assets() {
        return this._assets;
    }

    get labels() {
        return this._labels;
    }

    track(data) {
        this._assets.track(data);
        this._labels.track(data);
    }

    update() {
        this._assets.update();
        this._labels.update();
    }
}

export default Output;
